<template>
  <!-- Botão que abre o popup -->
  <button
    hidden
    ref="popupBtn"
    type="button"
    class="btn btn-primary"
    data-bs-toggle="modal"
    data-bs-target="#popup"
  ></button>

  <!-- Estrutura do Popup -->
  <div
    class="modal fade"
    id="popup"
    tabindex="-1"
    aria-labelledby="meuPopupLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content p-0 border-0" style="background: transparent">
        <!-- Botão de fechar (no canto superior direito) -->
        <div
          class="container-fluid modal-header border-0 p-0 d-flex justify-content-start"
        >
          <div class="col-md-8 text-start" style="padding-left: 1.5rem">
            <h6 class="fw-bold" v-if="popup.titulo">{{ popup.titulo }}</h6>
          </div>
          <div class="col-md-4 text-end">
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Fechar"
            ></button>
          </div>
        </div>
        <!-- Corpo com imagem de fundo -->
        <div v-if="popup.descricao" style="text-align: left; padding: 1.5rem">
          {{ popup.descricao }}
        </div>
        <div
          v-if="popup.imagem"
          class="modal-body d-flex align-items-center justify-content-center"
          style="min-height: 600px; background: transparent"
        >
          <img
            :src="popup.imagem.url"
            alt=""
            style="max-width: 100%; max-height: 100%; object-fit: contain"
          />
        </div>
        <!-- <div
          v-if="popup.imagem"
          class="modal-body d-flex align-items-center justify-content-center text-white"
          :style="{
            backgroundImage: 'url(' + popup.imagem.url + ')',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            width: 'auto',
            minHeight: '600px',
            color: 'red',
          }"
        ></div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive, ref, toRefs } from "vue";
import { PopupService } from "./popup.service";

export default {
  name: "ComponentPopup",
  setup() {
    const $servicePopup = new PopupService();
    let interval = null;

    const data = reactive({
      popupBtn: ref(),
      popups: ref([
        { titulo: "Aviso 1", mensagem: "Mensagem do aviso 1" },
        { titulo: "Aviso 2", mensagem: "Mensagem do aviso 2" },
        { titulo: "Aviso 3", mensagem: "Mensagem do aviso 3" },
      ]),
      popup: ref({}),
    });

    onMounted(async () => {
      await findPopup();
    });

    async function findPopup() {
      const response = await $servicePopup.findPopup();
      data.popups = response.data.filter((p) => p.ativo);

      // abrir modal somente se houver itens
      if (data.popups.length > 0) {
        data.popup = data.popups[0];
        const popupEl = document.getElementById("popup");
        if (popupEl) {
          data.popupBtn.click();
        }
        interval = setInterval(() => {
          popupNext();
        }, (data.popup.tempo_segundos ?? 5) * 1000);
      }
    }

    function popupNext() {
      clearInterval(interval);
      let i = data.popups.findIndex((b) => b.id === data.popup.id);
      if (i + 1 == data.popups.length) i = -1;
      data.popup = data.popups[i + 1];
      interval = setInterval(() => {
        popupNext();
      }, (data.popup.tempo_segundos ?? 5) * 1000);
    }

    return {
      ...toRefs(data),
    };
  },
};
</script>
<style scoped>
.btn-close.btn-close-white {
  filter: invert(1);
}
</style>
